module.exports = __webpack_public_path__ + "img/DE05762.c3f77857.png";